export default __webpack_public_path__ + "static/media/1 Sri krishna jewellers.fded4421.jpg";